import ProductionQuantityLimitsOutlinedIcon from "@mui/icons-material/ProductionQuantityLimitsOutlined";
// mohtasham React layouts
import SignIn from "layouts/authentication/sign-in";
import SignUp from "layouts/authentication/sign-up";
import RegisterCollaborator from "layouts/authentication/sign-up/registerCollaborator";

import NewOrder from "layouts/order/newOrder";
import Orders from "layouts/order";
import OrderLog from "layouts/order/orderLog";

// @mui icons
import DashboardIcon from "@mui/icons-material/Dashboard";
import ShoppingCartCheckoutOutlinedIcon from "@mui/icons-material/ShoppingCartCheckoutOutlined";
import GroupOutlinedIcon from "@mui/icons-material/GroupOutlined";
import PersonAddOutlinedIcon from "@mui/icons-material/PersonAddOutlined";
import PointOfSaleOutlinedIcon from "@mui/icons-material/PointOfSaleOutlined";
import ExitToAppOutlinedIcon from "@mui/icons-material/ExitToAppOutlined";
import Icon from "@mui/material/Icon";
import Users from "layouts/authentication/";
import Collaborator from "layouts/pofit/collaborator";
import CollaboratorDetails from "layouts/pofit/collaboratorDetails";
import Dashboard from "layouts/dashboard";

import Category from "layouts/catalogue/category";
import Categories from "layouts/catalogue/categories";
import Catalogues from "layouts/catalogue/catalogues";
import Catalogue from "layouts/catalogue/catalogue";
import CatalogueView from "layouts/catalogue/catalogueView";


import Aboutus from "layouts/aboutus";
import Contactus from "layouts/contactus";

const routes = [
  {
    type: "collapse",
    name: "داشبورد",
    key: "dashboard",
    show: true,
    auth: true,
    icon: <DashboardIcon />,
    route: "/dashboard",
    component: <Dashboard />,
  },
  {
    type: "collapse",
    name: "Order",
    key: "Order",
    show: false,
    auth: true,
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/neworder/:mode/:id/:show",
    component: <NewOrder />,
  },
  {
    type: "collapse",
    name: "OrderLog",
    key: "OrderLog",
    show: false,
    auth: true,
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/orderLog/:order",
    component: <OrderLog />,
  },
  
  {
    type: "collapse",
    name: "سفارشات درحال اجرا",
    key: "activeorders",
    show: true,
    auth: true,
    role: ["supperadmin", "saleadmin", "saller", "productionadmin", "designer","production"],
    icon: <ProductionQuantityLimitsOutlinedIcon />,
    route: "/activeorders",
    component: <Orders />,
  },
  {
    type: "collapse",
    name: "سفارشات ارسال شده",
    key: "deactiveorders",
    show: true,
    auth: true,
    role: ["supperadmin", "saleadmin", "saller", "productionadmin", "designer","production"],
    icon: <ShoppingCartCheckoutOutlinedIcon />,
    route: "/deactiveorders",
    component: <Orders />,
  },
  {
    type: "collapse",
    name: "لیست کاربران",
    key: "users",
    show: true,
    auth: true,
    role: ["supperadmin"],
    icon: <GroupOutlinedIcon />,
    route: "/users",
    component: <Users />,
  },
  {
    type: "collapse",
    name: "لیست کاربران",
    key: "users",
    show: false,
    auth: true,
    role: ["supperadmin"],
    icon: <GroupOutlinedIcon />,
    route: "/users/:role",
    component: <Users />,
  },
  {
    type: "collapse",
    name: "ثبت نام",
    role: ["supperadmin"],
    show: true,
    auth: false,
    key: "sign-up",
    icon: <PersonAddOutlinedIcon />,
    route: "/authentication/sign-up",
    component: <SignUp />,
  },
  {
    type: "collapse",
    name: "ثبت نام",
    show: false,
    auth: false,
    key: "sign-up",
    role: ["supperadmin"],
    icon: <PersonAddOutlinedIcon />,
    route: "/authentication/sign-up/:id",
    component: <SignUp />,
  },
  {
    type: "collapse",
    name: "ثبت نام",
    show: false,
    auth: false,
    key: "RegisterCollaborator",

    icon: <PersonAddOutlinedIcon />,
    route: "/authentication/registerCollaborator/:id",
    component: <RegisterCollaborator />,
  },
  {
    type: "collapse",
    name: "ثبت نام",
    show: false,
    auth: false,
    key: "RegisterCollaborator",
    icon: <PersonAddOutlinedIcon />,
    route: "/authentication/registerCollaborator/",
    component: <RegisterCollaborator />,
  },

  {
    type: "collapse",
    name: "حسابداری همکاران",
    show: true,
    auth: true,
    role: ["supperadmin", "saleadmin", "productionadmin", "accountants"],
    key: "collaborator",
    icon: <PointOfSaleOutlinedIcon />,
    route: "/collaborator",
    component: <Collaborator />,
  }, {
    type: "collapse",
    name: "درباره ما",
    show: true,
    auth: true,
    role: ["collaborator"],
    key: "aboutus",
    icon: <PointOfSaleOutlinedIcon />,
    route: "/aboutus",
    component: <Aboutus />,
  },{
    type: "collapse",
    name: "تماس با ما",
    show: true,
    auth: true,
    role: ["collaborator"],
    key: "contactus",
    icon: <PointOfSaleOutlinedIcon />,
    route: "/contactus",
    component: <Contactus />,
  },
  
  {
    type: "collapse",
    name: "حسابداری مشتری ",
    show: false,
    auth: true,
    role: ["supperadmin", "saleadmin", "saller", "accountants"],
    key: "CollaboratorDetails",
    icon: <PointOfSaleOutlinedIcon />,
    route: "/collaboratordetails/:userid/:mode/:name",
    component: <CollaboratorDetails />,
  },
  {
    type: "collapse",
    name: "حسابداری مشتری ",
    show: true,
    auth: true,
    role: ["supperadmin", "saleadmin", "saller", "accountants"],
    key: "CollaboratorDetails",
    icon: <PointOfSaleOutlinedIcon />,
    route: "/collaboratordetails/635682d06ceb014b0abbad6d/2/ملک آرا",
    component: <CollaboratorDetails />,
  },
  {
    type: "collapse",
    name: "دسته بندی کاتالوگ",
    key: "category",
    show: false,
    auth: true,
    role: ["supperadmin", "web"],
    icon: <DashboardIcon />,
    route: "/category",
    component: <Category />,
  },
  {
    type: "collapse",
    name: "دسته بندی کاتالوگ",
    key: "category",
    show: false,
    auth: true,
    role: ["supperadmin", "web"],
    icon: <DashboardIcon />,
    route: "/category/:id",
    component: <Category />,
  },
  {
    type: "collapse",
    name: "دسته بندی کاتالوگ",
    key: "categories",
    show: true,
    auth: true,
    role: ["supperadmin", "web"],
    icon: <DashboardIcon />,
    route: "/categories",
    component: <Categories />,
  },
  {
    type: "collapse",
    name: " مدیریت کاتالوگ",
    key: "Catalogues",
    show: true,
    auth: true,
    role: ["supperadmin", "web"],
    icon: <DashboardIcon />,
    route: "/Catalogues",
    component: <Catalogues />,
  },
  {
    type: "collapse",
    name: "کاتالوگ",
    key: "catalogue",
    show: false,
    auth: true,
    role: ["supperadmin", "web"],
    icon: <DashboardIcon />,
    route: "/catalogue/",
    component: <Catalogue />,
  },
  {
    type: "collapse",
    name: "کاتالوگ",
    key: "catalogue",
    show: false,
    auth: true,
    role: ["supperadmin", "web"],
    icon: <DashboardIcon />,
    route: "/catalogue/:id",
    component: <Catalogue />,
  },
  {
    type: "collapse",
    name: "کاتالوگ",
    key: "catalogueview",
    show: true,
    auth: true,
    icon: <DashboardIcon />,
    route: "/catalogueview",
    component: <CatalogueView />,
  },

  {
    type: "collapse",
    name: "خروج",
    key: "sign-out",
    auth: true,
    show: true,
    icon: <ExitToAppOutlinedIcon />,
    route: "/authentication/sign-in",
    component: <SignIn />,
  },
];

export default routes;
